import {
  Box,
  Flex,
  Text,
  Image,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import checkCircleSrc from '../../../assets/images/check-circle.svg';
import pilotIconSrc from '../../../assets/images/pilot-plan.svg';
import scaleIconSrc from '../../../assets/images/scale-plan.svg';
import enterpriseIconSrc from '../../../assets/images/enterprise-plan.svg';
import { useContext } from 'react';
import {
  formatFeature,
  formatGbpFromMinorUnits,
  monthlyAmountMinorUnits,
  formatCustomPlanName,
} from '../../../utils/subscriptionUtils';
import { MeContext } from '../../../context/MeContext';

const SubscriptionPlanDetails = ({ plan }) => {
  const { state } = useContext(MeContext);
  const watermarkFree = state?.watermarkFree;
  const features = watermarkFree
    ? plan?.features?.filter((f) => f.key !== 'passentry_watermark')
    : plan?.features;

  return (
    <Box
      bg="white"
      w="100%"
      h="100%"
      borderRadius="10px"
      px={8}
      py={8}
      minW="200px"
    >
      <Flex direction="column" gap={4}>
        <Image
          src={
            plan?.rank === 1
              ? pilotIconSrc
              : plan?.rank === 2
                ? scaleIconSrc
                : enterpriseIconSrc
          }
          alt="plan-icon"
          w="50px"
          h="50px"
        />
        <Flex direction="column">
          <Text textStyle="headingFamilyMedium" fontSize="32px" color="#101828">
            {formatCustomPlanName(plan?.name)}
          </Text>
          <Flex direction="column" align="flex-start" gap={0.5}>
            <Flex direction="row" align="center" gap={2}>
              <Text
                textStyle="headingFamilySemiBold"
                fontSize="42px"
                fontWeight="bold"
                color="#101828"
              >
                {plan?.rank === 3
                  ? 'Custom price'
                  : formatGbpFromMinorUnits(
                      monthlyAmountMinorUnits(plan?.selectedPrice),
                      { wholePounds: true }
                    )}
              </Text>
            </Flex>
            {plan?.name !== 'Enterprise' && (
              <Text
                textStyle="headingFamilyRegular"
                fontSize="12px"
                color="#465467"
              >
                Per month, billed{' '}
                {plan?.selectedPrice?.interval === 'year'
                  ? 'annually'
                  : 'monthly'}
              </Text>
            )}
          </Flex>
          <Text textStyle="headingFamilyMedium" fontSize="16px" color="#101828">
            {plan?.description}
          </Text>
        </Flex>
        <UnorderedList spacing={3} mt={4} ml={0} mb={3}>
          {features?.map((feature) => (
            <ListItem display="flex" alignItems="center" gap={2}>
              <Image src={checkCircleSrc} alt="check" w="20px" h="20px" />
              <Text
                textStyle="headingFamilyMedium"
                fontSize="14px"
                color="#101828"
              >
                {formatFeature(feature)}
              </Text>
            </ListItem>
          ))}
        </UnorderedList>
      </Flex>
    </Box>
  );
};

export default SubscriptionPlanDetails;
